import React, { useState } from "react";
import {
  FaSearch, FaFilter, FaHardHat, FaUser,
  FaCalendarAlt, FaMoneyBillWave, FaCheckCircle,
} from "react-icons/fa";
import api from "../../api/axiosClient";

const S = `
  .jr-wrap * { box-sizing: border-box; }

  /* Stats row */
  .jr-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem; margin-bottom: 1.5rem;
  }
  .jr-stat {
    background: #111114; border: 1px solid rgba(255,255,255,.06);
    border-radius: 14px; padding: 1.1rem 1.25rem;
    display: flex; justify-content: space-between; align-items: center;
    position: relative; overflow: hidden;
  }
  .jr-stat::after {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
    background: var(--accent, #FFD700);
  }
  .jr-stat-label { font-size: .68rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: #555560; margin-bottom: 6px; }
  .jr-stat-val   { font-family: 'Playfair Display', serif; font-size: 1.6rem; font-weight: 800; color: var(--accent, #FFD700); line-height: 1; }
  .jr-stat-icon  { width: 38px; height: 38px; border-radius: 10px; background: rgba(255,215,0,.07); display: flex; align-items: center; justify-content: center; color: var(--accent, #FFD700); font-size: .85rem; }

  /* Toolbar */
  .jr-toolbar { display: flex; gap: 10px; margin-bottom: 1.25rem; flex-wrap: wrap; }
  .jr-search {
    flex: 1; min-width: 200px;
    display: flex; align-items: center; gap: 10px;
    background: #111114; border: 1.5px solid rgba(255,255,255,.07);
    border-radius: 11px; padding: .65rem 1rem; transition: border-color .2s;
  }
  .jr-search:focus-within { border-color: rgba(255,215,0,.3); }
  .jr-search input { flex: 1; background: none; border: none; outline: none; color: #ECECEC; font-family: 'DM Sans', sans-serif; font-size: .88rem; }
  .jr-search input::placeholder { color: #3a3a44; }

  .jr-filter-wrap { display: flex; align-items: center; gap: 8px; }
  .jr-filter-wrap select {
    background: #111114; border: 1.5px solid rgba(255,255,255,.07);
    border-radius: 11px; padding: .65rem 1rem;
    color: #9A9AA5; font-family: 'DM Sans', sans-serif; font-size: .84rem;
    outline: none; cursor: pointer; transition: border-color .2s;
  }
  .jr-filter-wrap select:focus { border-color: rgba(255,215,0,.3); }

  /* Table */
  .jr-table-wrap {
    background: #111114; border: 1px solid rgba(255,255,255,.06);
    border-radius: 16px; overflow: hidden;
  }
  .jr-table { width: 100%; border-collapse: collapse; min-width: 800px; }
  .jr-table thead tr {
    background: linear-gradient(90deg, #1a1400, #0d0d10);
    border-bottom: 1px solid rgba(255,215,0,.1);
  }
  .jr-table thead th {
    padding: .9rem 1.25rem; font-size: .65rem; font-weight: 700;
    letter-spacing: .1em; text-transform: uppercase;
    color: #555560; text-align: left; white-space: nowrap;
  }
  .jr-table tbody tr { border-bottom: 1px solid rgba(255,255,255,.04); transition: background .12s; }
  .jr-table tbody tr:last-child { border-bottom: none; }
  .jr-table tbody tr:hover { background: rgba(255,215,0,.02); }
  .jr-table td { padding: .95rem 1.25rem; font-size: .84rem; color: #9A9AA5; vertical-align: middle; }

  /* Job ID */
  .jr-id {
    font-family: 'JetBrains Mono', monospace; font-size: .78rem; font-weight: 600;
    color: #FFD700; background: rgba(255,215,0,.08);
    border: 1px solid rgba(255,215,0,.15); border-radius: 7px;
    padding: 3px 9px; display: inline-block;
  }

  /* Client cell */
  .jr-client { font-weight: 600; color: #ECECEC; }
  .jr-phone  { font-size: .72rem; color: #555560; margin-top: 1px; }

  /* Service tag */
  .jr-svc {
    background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.08);
    color: #9A9AA5; border-radius: 20px; padding: 3px 10px; font-size: .76rem;
    display: inline-block;
  }

  /* Budget */
  .jr-budget { font-family: 'JetBrains Mono', monospace; font-weight: 600; color: #ECECEC; }

  /* Status pill */
  .jr-pill {
    display: inline-flex; align-items: center; gap: 5px;
    border-radius: 20px; padding: 3px 10px;
    font-size: .68rem; font-weight: 700;
  }
  .jr-pill-pending   { background: rgba(251,191,36,.1);  color: #fbbf24; border: 1px solid rgba(251,191,36,.2); }
  .jr-pill-assigned  { background: rgba(59,130,246,.1);  color: #60a5fa; border: 1px solid rgba(59,130,246,.2); }
  .jr-pill-active    { background: rgba(139,92,246,.1);  color: #a78bfa; border: 1px solid rgba(139,92,246,.2); }
  .jr-pill-completed { background: rgba(34,197,94,.1);   color: #4ade80; border: 1px solid rgba(34,197,94,.2); }
  .jr-pill-paid      { background: rgba(34,197,94,.15);  color: #4ade80; border: 1px solid rgba(34,197,94,.3); }
  .jr-pill-cancelled { background: rgba(239,68,68,.1);   color: #f87171; border: 1px solid rgba(239,68,68,.2); }
  .jr-pill-default   { background: rgba(255,255,255,.05); color: #555560; border: 1px solid rgba(255,255,255,.08); }

  /* Assign row */
  .jr-assign { display: flex; align-items: center; gap: 7px; min-width: 240px; }
  .jr-assign select {
    flex: 1; background: #0c0c0e;
    border: 1.5px solid rgba(255,255,255,.08); border-radius: 8px;
    padding: .45rem .75rem; color: #ECECEC;
    font-family: 'DM Sans', sans-serif; font-size: .78rem;
    outline: none; cursor: pointer; transition: border-color .2s;
  }
  .jr-assign select:focus { border-color: rgba(255,215,0,.3); }
  .jr-assign-btn {
    padding: .45rem .9rem; background: linear-gradient(135deg, #FFD700, #F59E0B);
    color: #000; border: none; border-radius: 8px;
    font-family: 'DM Sans', sans-serif; font-size: .78rem; font-weight: 700;
    cursor: pointer; white-space: nowrap; transition: all .15s;
    box-shadow: 0 2px 10px rgba(255,215,0,.2);
  }
  .jr-assign-btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 16px rgba(255,215,0,.35); }
  .jr-assign-btn:disabled { opacity: .5; cursor: not-allowed; transform: none; }

  .jr-assigned-label {
    display: inline-flex; align-items: center; gap: 6px;
    font-size: .78rem; color: #4ade80; font-weight: 600;
  }

  /* Error banner */
  .jr-err {
    background: rgba(239,68,68,.08); border: 1px solid rgba(239,68,68,.2);
    border-radius: 10px; padding: .75rem 1rem;
    font-size: .82rem; color: #f87171; margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }

  /* Empty */
  .jr-empty {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 4rem 2rem; gap: .75rem;
  }
  .jr-empty h4 { font-family: 'Playfair Display', serif; font-size: 1rem; font-weight: 800; color: #ECECEC; margin: 0; }
  .jr-empty p  { font-size: .82rem; color: #555560; margin: 0; }

  @media (max-width: 900px) { .jr-table-wrap { overflow-x: auto; } }
`;

const STATUS_CLASSES = {
  Pending:     "jr-pill-pending",
  Assigned:    "jr-pill-assigned",
  Accepted:    "jr-pill-active",
  "In Progress": "jr-pill-active",
  Completed:   "jr-pill-completed",
  Paid:        "jr-pill-paid",
  Cancelled:   "jr-pill-cancelled",
};

const ALL_STATUSES = ["All", "Pending", "Assigned", "Accepted", "In Progress", "Completed", "Paid", "Cancelled"];

export default function JobRequests({
  jobs = [],
  jobsLoading,
  approvedCraftsmen = [],
  selectedCraftsmen = {},
  setSelectedCraftsmen,
  onSuccessAssign,
}) {
  const [assigningId, setAssigningId] = useState(null);
  const [errorMsg, setErrorMsg]       = useState("");
  const [search, setSearch]           = useState("");
  const [statusFilter, setStatus]     = useState("All");

  if (jobsLoading) {
    return (
      <div style={{ textAlign: "center", padding: "4rem 2rem" }}>
        <div className="spinner-border" style={{ color: "#FFD700", width: "2.5rem", height: "2.5rem" }} role="status" />
        <p style={{ marginTop: "1rem", color: "#555560", fontSize: ".88rem" }}>Loading jobs...</p>
      </div>
    );
  }

  const assignCraftsman = async (jobId) => {
    const craftsmanId = selectedCraftsmen[jobId];
    if (!craftsmanId) { setErrorMsg("Select a craftsman before assigning."); return; }
    setAssigningId(jobId); setErrorMsg("");
    try {
      await api.post(`admin/jobs/${jobId}/assign/`, { craftsman: craftsmanId });
      if (onSuccessAssign) onSuccessAssign();
    } catch (err) {
      const msg = err.response?.data?.error || "Assignment failed. Please try again.";
      setErrorMsg(msg);
    } finally {
      setAssigningId(null);
    }
  };

  const sorted = [...jobs].sort((a, b) => b.id - a.id);
  const filtered = sorted.filter(j => {
    const q = search.toLowerCase();
    const matchSearch = !q || (j.name || "").toLowerCase().includes(q) || (j.service || "").toLowerCase().includes(q) || String(j.id).includes(q);
    const matchStatus = statusFilter === "All" || j.status === statusFilter;
    return matchSearch && matchStatus;
  });

  const stats = [
    { lbl: "Total",     val: jobs.length,                                  accent: "#FFD700", icon: <FaHardHat /> },
    { lbl: "Pending",   val: jobs.filter(j => j.status === "Pending").length,  accent: "#fbbf24", icon: <FaUser /> },
    { lbl: "Active",    val: jobs.filter(j => ["Assigned","Accepted","In Progress"].includes(j.status)).length, accent: "#3b82f6", icon: <FaCalendarAlt /> },
    { lbl: "Completed", val: jobs.filter(j => j.status === "Completed").length, accent: "#22c55e", icon: <FaCheckCircle /> },
    { lbl: "Revenue",   val: `KSh ${jobs.filter(j => j.status === "Paid").reduce((a, j) => a + (Number(j.budget) || 0), 0).toLocaleString()}`, accent: "#22c55e", icon: <FaMoneyBillWave /> },
  ];

  return (
    <div className="jr-wrap">
      <style>{S}</style>

      {/* Stats */}
      <div className="jr-stats">
        {stats.map((s, i) => (
          <div key={i} className="jr-stat" style={{ "--accent": s.accent }}>
            <div>
              <div className="jr-stat-label">{s.lbl}</div>
              <div className="jr-stat-val">{s.val}</div>
            </div>
            <div className="jr-stat-icon" style={{ background: `${s.accent}10`, color: s.accent }}>{s.icon}</div>
          </div>
        ))}
      </div>

      {/* Error */}
      {errorMsg && (
        <div className="jr-err">
          <span>⚠</span>
          <span>{errorMsg}</span>
          <button onClick={() => setErrorMsg("")} style={{ marginLeft: "auto", background: "none", border: "none", color: "#f87171", cursor: "pointer", fontSize: ".9rem" }}>✕</button>
        </div>
      )}

      {/* Toolbar */}
      <div className="jr-toolbar">
        <div className="jr-search">
          <FaSearch style={{ color: "#3a3a44", fontSize: ".82rem", flexShrink: 0 }} />
          <input
            placeholder="Search by client, service or job ID..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          {search && (
            <span onClick={() => setSearch("")} style={{ color: "#555", cursor: "pointer", fontSize: ".78rem" }}>Clear</span>
          )}
        </div>
        <div className="jr-filter-wrap">
          <FaFilter style={{ color: "#555560", fontSize: ".78rem" }} />
          <select value={statusFilter} onChange={e => setStatus(e.target.value)}>
            {ALL_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="jr-table-wrap">
        {filtered.length === 0 ? (
          <div className="jr-empty">
            <div style={{ fontSize: "2rem", color: "#333" }}>📋</div>
            <h4>{search || statusFilter !== "All" ? "No jobs match your filter" : "No jobs yet"}</h4>
            <p>{search || statusFilter !== "All" ? "Try adjusting your search or filter." : "Job requests will appear here once submitted."}</p>
          </div>
        ) : (
          <table className="jr-table">
            <thead>
              <tr>
                <th>Job #</th>
                <th>Client</th>
                <th>Service</th>
                <th>Budget</th>
                <th>Status</th>
                <th>Assign Craftsman</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(job => {
                const isAssigned = !!job.craftsman;
                const pillClass = STATUS_CLASSES[job.status] || "jr-pill-default";

                return (
                  <tr key={job.id}>
                    <td><span className="jr-id">#{job.id}</span></td>
                    <td>
                      <div className="jr-client">{job.name || "—"}</div>
                      {job.phone && <div className="jr-phone">{job.phone}</div>}
                    </td>
                    <td>
                      {job.service
                        ? <span className="jr-svc">{job.service}</span>
                        : <span style={{ color: "#333" }}>—</span>
                      }
                    </td>
                    <td>
                      <span className="jr-budget">
                        {job.budget ? `KSh ${Number(job.budget).toLocaleString()}` : "—"}
                      </span>
                    </td>
                    <td>
                      <span className={`jr-pill ${pillClass}`}>{job.status || "—"}</span>
                    </td>
                    <td>
                      {isAssigned && job.status !== "Pending" ? (
                        <span className="jr-assigned-label">
                          <FaCheckCircle size={11} />
                          {job.craftsman?.full_name || "Assigned"}
                        </span>
                      ) : (
                        <div className="jr-assign">
                          <select
                            value={selectedCraftsmen[job.id] || ""}
                            onChange={e => setSelectedCraftsmen({ ...selectedCraftsmen, [job.id]: e.target.value })}
                          >
                            <option value="">Select craftsman...</option>
                            {approvedCraftsmen.map(c => (
                              <option key={c.id} value={c.id}>
                                {c.full_name}{c.primary_service ? ` — ${c.primary_service}` : ""}
                              </option>
                            ))}
                          </select>
                          <button
                            className="jr-assign-btn"
                            disabled={!selectedCraftsmen[job.id] || assigningId === job.id}
                            onClick={() => assignCraftsman(job.id)}
                          >
                            {assigningId === job.id ? "..." : "Assign"}
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}